import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(({ typographyPresets, colors }) => ({
    label: {
        ...typographyPresets.labelPrimary,
    },
    input: {
        width: '100%',
        height: '36px',
        padding: '10px',
        borderRadius: '2px',
        color: `${colors.black} !important`, //TODO check why !important is necessary here and fix it
        '&:focus': {
            outline: 'transparent',
            border: 'solid 1px #f73153',
        },
    },
    formCtrl: {
        margin: '10px 0',
    },
    error: {
        ...typographyPresets.labelPrimary,
        color: 'red',
        margin: '10px 2px',
    },
    labelContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    infoContainer: {
        position: 'relative',
    },
    info: {
        fontSize: '14px',
        color: 'black',
    },
    tooltip: {
        position: 'absolute',
        top: '50%',
        right: '20px',
        fontSize: '11px',
        transform: 'translateY(-50%)',
        color: 'white',
        background: 'black',
        padding: '5px',
        borderRadius: '3px',
        '&:before': {
            position: 'absolute',
            content: "''",
            borderColor: 'transparent',
            borderStyle: 'solid',
        },
    },
    inputContainer: {
        position: 'relative',
    },
    optionContainer: {
        position: 'absolute',
        left: 0,
        right: 0,
        transform: 'translateX(-50%)', //TODO see if we can make simpleDropdown inject this in children
        backgroundColor: colors.light.offWhite1,
        boxShadow:
            '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
        borderRadius: '4px',
        padding: '0',
    },
    option: {
        listStyleType: 'none',
        padding: '10px 10px',
        cursor: 'pointer',
        ...typographyPresets.labelPrimary,
        '&:hover': {
            backgroundColor: colors.light.lightGray,
        },
    },
}))
